import React from 'react'
import LightWeightCharting from './LightWeightCharting'
import FiveMinuteLightWeightChart from "./pages/FiveMinuteLightWeightChart"
const App = () => {
  return (
    <>
      <LightWeightCharting />
    </>
  )
}

export default App
